/**
 * Created by alvinoktavianus (https://github.com/alvinoktavianus)
 * on 23/03/18
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
  setShowOutletDetailModal,
  onClickActivateButton,
} from 'actions/setting/paymentMethod';
import { useMokaOutletPropsFirst } from 'utils/formatter';
import styles from './styles.css';

class OutletDetailModal extends Component {
  _onClickActivatePaymentMethod = () => {
    const { userData, businessName, paymentMethodKey } = this.props;
    const selectedPaymentMethodList = [paymentMethodKey];
    this.props.dispatch(
      onClickActivateButton(selectedPaymentMethodList, userData, businessName)
    );
  };

  render() {
    const {
      openActivateModal,
      handleClose,
      outlets,
      outletStatus,
      paymentMethodKey,
      userData,
    } = this.props;

    if (!paymentMethodKey || !outletStatus[paymentMethodKey.id] || !userData) {
      return <div />;
    }

    return (
      <Modal show={openActivateModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Outlet Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={styles['table-wrapper']}>
            <div>
              <table
                className={`table ${styles['table-no-margin']} ${
                  styles['table-header']
                }`}
              >
                <thead>
                  <tr>
                    <th className={styles['table-outlet-name']}>Outlet Name</th>
                    <th className={styles['table-status']}>Status</th>
                  </tr>
                </thead>
              </table>
            </div>
            <div className={styles['table-body-wrapper']}>
              <table className={`table ${styles['table-no-margin']}`}>
                <tbody>
                  {outlets.map(outlet => {
                    return (
                      <tr key={outlet.id}>
                        <td className={styles['table-outlet-name']}>
                          <div className={styles['text-wrapper']}>
                            <div className={styles['text-elipsis']}>
                              {useMokaOutletPropsFirst(outlet, o => o.name)}
                            </div>
                          </div>
                        </td>
                        <td className={styles['table-status']}>
                          {outletStatus[paymentMethodKey.id] &&
                            outletStatus[paymentMethodKey.id][outlet.id] ===
                              'PENDING' && (
                              <span className={styles['waiting-for-approval']}>
                                Waiting for Approval
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id="tooltip">
                                      It usually takes 1 - 3 business days, and
                                      we will notify you via email once it is
                                      approved.
                                    </Tooltip>
                                  }
                                >
                                  <img
                                    style={{
                                      position: 'relative',
                                      top: '-2px',
                                      marginLeft: 10,
                                      cursor: 'pointer',
                                    }}
                                    src={require('assets/images/info-tooltip.png')}
                                  />
                                </OverlayTrigger>
                              </span>
                            )}
                          {outletStatus[paymentMethodKey.id] &&
                            outletStatus[paymentMethodKey.id][outlet.id] ===
                              'APPROVED' && (
                              <span className={styles.active}>Active</span>
                            )}
                          {outletStatus[paymentMethodKey.id] &&
                            outletStatus[paymentMethodKey.id][outlet.id] ===
                              'REJECTED' && (
                              <span className={styles.rejected}>
                                Not Approved
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id="tooltip">
                                      Please Call 1500970 for more information
                                    </Tooltip>
                                  }
                                >
                                  <img
                                    style={{
                                      position: 'relative',
                                      top: '-2px',
                                      marginLeft: 10,
                                      cursor: 'pointer',
                                    }}
                                    src={require('assets/images/info-tooltip.png')}
                                  />
                                </OverlayTrigger>
                              </span>
                            )}
                          {outletStatus[paymentMethodKey.id] &&
                            outletStatus[paymentMethodKey.id][outlet.id] ===
                              'NOT_AVAILABLE' && (
                              <span className={styles.rejected}>
                                Not Available
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id="tooltip">
                                      Please Call 1500970 for more information
                                    </Tooltip>
                                  }
                                >
                                  <img
                                    style={{
                                      position: 'relative',
                                      top: '-2px',
                                      marginLeft: 10,
                                      cursor: 'pointer',
                                    }}
                                    src={require('assets/images/info-tooltip.png')}
                                  />
                                </OverlayTrigger>
                              </span>
                            )}
                          {!outletStatus[paymentMethodKey.id][outlet.id] && (
                            <span className={styles['waiting-for-approval']}>
                              Inactive
                            </span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-default pull-left"
            onClick={() => {
              this.props.dispatch(setShowOutletDetailModal(false));
            }}
          >
            Cancel
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  const {
    openActivateModal,
    outlets,
    outletStatus,
    paymentMethodKey,
  } = state.setting.paymentMethod;
  return {
    openActivateModal,
    outlets,
    outletStatus,
    paymentMethodKey,
    userData: state.moka.user,
  };
}

export default connect(mapStateToProps)(OutletDetailModal);
